<div class="page-layout carded fullwidth inner-scroll">
  <div class="center">
    <div class="header" fxLayout="row" fxLayoutAlign="space-between center">
      <span class="h1"> {{ 'LOCATIONS.TITLE' | translate }} </span>

      <div class="page-buttons" fxHide.xs>
        <button
          mat-stroked-button
          [matTooltip]="'LOCATIONS.ADD' | translate"
          (click)="openDialog()"
          [disabled]="!hasCreateLocationPermission"
        >
          <i
            matTooltipPosition="left"
            class="angularjs-fuse-icon icon-plus"
            [matTooltip]="'LOCATIONS.PERMISSIONS.NO_CREATE' | translate"
            [matTooltipDisabled]="hasCreateLocationPermission"
          ></i>
        </button>

        <button
          *ngIf="hasCreateExportPermission"
          mat-stroked-button
          matTooltip="{{ 'LOCATIONS.EXPORT_EXCEL' | translate }}"
          (click)="openExportDialog()"
          [disabled]="!totalCount"
        >
          <i class="angularjs-fuse-icon icon-file-excel"></i>
        </button>

        <button mat-stroked-button [matTooltip]="'LOCATIONS.CHANGE_VIEW' | translate" (click)="showMap = !showMap">
          <i class="angularjs-fuse-icon {{ showMap ? 'icon-table' : 'icon-map' }}"></i>
        </button>

        <button
          *ngIf="filters.filtered"
          mat-stroked-button
          [matTooltip]="'LOCATIONS.FILTER_CLEAR' | translate"
          (click)="clearFilters()"
        >
          <i class="angularjs-fuse-icon icon-filter-remove"></i>
        </button>

        <button
          mat-stroked-button
          [matTooltip]="'LOCATIONS.FILTER.TITLE' | translate"
          (click)="toggleSidebarOpen('filterLocations')"
        >
          <i class="angularjs-fuse-icon icon-filter"></i>
        </button>

        <button mat-stroked-button [matTooltip]="'LOCATIONS.RELOAD' | translate" (click)="reload.emit()">
          <i class="angularjs-fuse-icon icon-reload small"></i>
        </button>
      </div>

      <div class="page-buttons" fxShow="false" fxShow.xs>
        <button mat-stroked-button [matMenuTriggerFor]="menuLocations">
          <mat-icon class="accent-500-fg">keyboard_arrow_down</mat-icon>
        </button>

        <mat-menu #menuLocations>
          <button
            mat-menu-item
            fxLayout="row"
            fxLayoutAlign="start center"
            (click)="openDialog()"
            [disabled]="!hasCreateLocationPermission"
          >
            <i class="angularjs-fuse-icon icon-plus mr-4"></i>
            <span>{{ 'LOCATIONS.ADD' | translate }}</span>
          </button>

          <button
            *ngIf="hasCreateExportPermission"
            mat-menu-item
            fxLayout="row"
            fxLayoutAlign="start center"
            (click)="openExportDialog()"
            [disabled]="!totalCount"
          >
            <i class="angularjs-fuse-icon icon-file-excel"></i>
            <span>{{ 'LOCATIONS.EXPORT_EXCEL' | translate }}</span>
          </button>

          <button mat-menu-item fxLayout="row" fxLayoutAlign="start center" (click)="showMap = !showMap">
            <i class="angularjs-fuse-icon {{ showMap ? 'icon-table' : 'icon-map' }} mr-4"></i>
            <span>{{ 'LOCATIONS.CHANGE_VIEW' | translate }}</span>
          </button>

          <button *ngIf="filtered" mat-menu-item fxLayout="row" fxLayoutAlign="start center" (click)="clearFilters()">
            <i class="angularjs-fuse-icon icon-filter-remove mr-4"></i>
            <span>{{ 'LOCATIONS.FILTER_CLEAR' | translate }}</span>
          </button>

          <button
            mat-menu-item
            fxLayout="row"
            fxLayoutAlign="start center"
            (click)="toggleSidebarOpen('filterLocations')"
          >
            <i class="angularjs-fuse-icon icon-filter mr-4"></i>
            <span>{{ 'LOCATIONS.FILTER.TITLE' | translate }}</span>
          </button>

          <button mat-menu-item fxLayout="row" fxLayoutAlign="start center" (click)="reload.emit()">
            <i class="angularjs-fuse-icon icon-reload small mr-4"></i>
            <span>{{ 'LOCATIONS.RELOAD' | translate }}</span>
          </button>
        </mat-menu>
      </div>
    </div>

    <datatable-locations
      *ngIf="!showMap"
      class="content-card datatable"
      [reload]="reload"
      [filters]="filters"
      (totalCountLocations)="totalCount = $event"
      [hasEditLocationPermission]="hasEditLocationPermission"
    >
    </datatable-locations>

    <map-locations class="content-card" [reload]="reload" [filters]="filters" *ngIf="showMap"></map-locations>
  </div>
</div>

<fuse-sidebar name="filterLocations" key="filterLocations" position="right" lockedOpen="true">
  <filter-locations class="sidebar-filter"></filter-locations>
</fuse-sidebar>
